/*
 FileAssignment component
 url match: / or /login
 Displays email id and password field
 with FileAssignment button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputAdornment from '@material-ui/core/InputAdornment';
import { createMuiTheme } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const documentTypes = ['GOVT_ID', 'MEDICAL_RECORDS', 'FINANCE', 'ATM_SLIPS', 'HAND_WRITTEN', 'RENT_AGREEMENT'];
const theme = createMuiTheme({
    overrides: {
        MuiFilledInput: {
            root: {
                color: 'white',
                borderRadius: '4px',
                backgroundColor: '#202430',
                paddingRight: '0px',
                paddingTop: '0px'
            }

        },
        MuiInputAdornment: {
            root: {
                color: "#868a8e",
                "&$focused": { // increase the specificity for the pseudo class
                    color: "black"
                }
            }
        },
        MuiInputLabel: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule
                color: "#868a8e",
                "&$focused": { // increase the specificity for the pseudo class
                    color: "#868a8e"
                }
            }
        },

    }
})
@inject('documentStore', 'userStore', 'commonStore', 'dashboardStore')
@observer
class FileAssignment extends React.Component {
    state = {
        selected: 'edit',
        assignedUser: '',
        comment: '',
        selectedDocType: 'GOVT_ID'
    }

    componentDidMount() {
        this.props.userStore.getUserList(true)
    }

    closeDialog = () => {
        this.setState({ comment: '', assignedUser: '' })
        this.props.dashboardStore.closeFileAssignDialog();
    }

    modifyText = (text) => {
        return this.props.commonStore.modifyText(text)
    }

    handleChange = (event) => {
        event.stopPropagation()
        this.setState({
            selected: event.target.value
        })
    }

    handleTextChange = (event, value) => {
        this.setState({
            assignedUser: value
        })
    }

    handleFieldChange = () => {
        this.setState({
            assignedUser: ''
        })
    }

    onClickNext = () => {
        if (this.state.assignedUser === undefined) {
            this.props.commonStore.handleOpenSnackBar("Please select user before proceeding!", "info")
            return
        }
        if (this.state.selectedDocType === undefined || !this.state.selectedDocType.length) {
            this.props.commonStore.handleOpenSnackBar("Please select document type before proceeding!", "info")
            return
        }
        this.props.dashboardStore.openUpload(this.state.assignedUser, this.state.comment, this.state.selectedDocType);
        this.setState({
            assignedUser: '',
            selectedDocType: ''
        })
    }

    assignFiles = () => {
        if (this.state.assignedUser === undefined) {
            this.props.commonStore.handleOpenSnackBar("Please select user before proceeding!", "info")
            return
        }
        this.props.userStore.assignDocuments(this.state.assignedUser);
        this.setState({
            assignedUser: ''
        })
    }

    handleCommentChange = (e) => {
        this.setState({ comment: e.target.value });
    }

    getOptions = (list) => {
        let temp = []
        list.map((option, index) => {
            temp.push(option.userFullName + "," + option.email)
        })
        return temp
    }

    render() {
        const { openFileAssignDialog } = this.props.dashboardStore;
        const { userList, serverDown } = this.props.userStore
        const { classes } = this.props;
        const { selected, assignedUser, comment, selectedDocType } = this.state
        return (
            <Dialog BackdropProps={{
                classes: {
                    root: classes.backdrop
                }
            }} disableBackdropClick={true} disableEscapeKeyDown={true} classes={{ paper: classes.fileDialog }} open={openFileAssignDialog} onClose={this.closeDialog} aria-labelledby="form-dialog-title">
                <DialogTitle style={{ color: 'white' }}>Assign files to</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        noOptionsText="No matching users found"
                        forcePopupIcon={false}
                        id="combo-box-demo"
                        options={this.getOptions(userList)}
                        value={assignedUser.split(",") && assignedUser.split(",")[0]}
                        renderOption={(option, { selected }) => (

                            <React.Fragment>
                                <div className="colFlex">
                                    <div>{option.split(",")[0]}</div>
                                    <div style={{ color: theme.palette.steelGray, fontSize: '12px' }}>{option.split(",")[1]}</div>
                                </div>
                            </React.Fragment>
                        )}
                        disableClearable={true}
                        getOptionLabel={option => option}

                        classes={
                            { inputRoot: classes.inputRoot }
                        }
                        onChange={this.handleTextChange}
                        renderInput={params => (
                            <div>
                                <TextField style={{ color: 'white', margin: 0 }}
                                    {...params}
                                    value={assignedUser.split(",") && assignedUser.split(",")[0]}
                                    onChange={(e) => this.handleFieldChange()}
                                    InputProps={{
                                        ...params.InputProps,
                                        disableUnderline: true,
                                        startAdornment: <InputAdornment tabIndex="-1" style={{ marginTop: '1px' }} position="start"><span style={{ color: 'white' }}>To :</span></InputAdornment>
                                    }}
                                    color="primary"
                                    margin="normal"
                                    variant="filled"
                                    fullWidth
                                />
                            </div>
                        )}
                    />

                    {!this.props.userStore.openAssignDialog ? <Autocomplete style={{ marginTop: '2vh' }}
                        noOptionsText="No matching document type found"
                        id="combo-box-demo"
                        popupIcon=<ArrowDropDownIcon style={{ color: 'white' }} />
                        options={documentTypes}
                        renderOption={(option, { selected }) => (
                        <React.Fragment>
                            <div className="colFlex">
                                <div>{option && this.modifyText(option)}</div>
                            </div>
                        </React.Fragment>
                    )}
                        disableClearable={true}
                        getOptionDisabled= {option => option === 'MEDICAL_RECORDS' && serverDown}
                        getOptionLabel={option => option && this.modifyText(option)}
                        classes={
                        { inputRoot: classes.inputRoot }
                    }
                        onChange={(e, value) => this.setState({ selectedDocType: value })}
                        renderInput={params => (
                        <div>
                            <TextField style={{ color: 'white', margin: 0 }}
                                {...params}
                                value={selectedDocType}
                                onChange={(e) => this.setState({ selectedDocType: '' })}

                                InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    startAdornment: <InputAdornment tabIndex="-1" style={{ marginTop: '1px' }} position="start"><span style={{ color: 'white' }}>Document Type :</span></InputAdornment>
                                }}
                                color="primary"
                                margin="normal"
                                variant="filled"
                                fullWidth
                            />
                        </div>
                    )}
                    /> : null}
                    <TextField style={{ color: 'white', marginTop: '2vh' }}
                        label="Add a message (optional). Max. 300 characters"
                        inputProps={{
                            maxLength: 300,
                        }}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        color="primary"
                        margin="normal"
                        variant="filled"
                        fullWidth
                        multiline
                        rows={6}
                        value={comment}
                        onChange={this.handleCommentChange}

                    />
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10vh', justifyContent: 'center' }}>
                        <Button style={{ width: '7vw', marginTop: 0, marginBottom: '20px', marginRight: '1vw', backgroundColor: '#acb4c6' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.closeDialog()}>
                            Cancel
                        </Button>
                        {!this.props.userStore.openAssignDialog ?
                            <Button style={{ width: '7vw', marginTop: 0, marginBottom: '20px' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.onClickNext()}>
                                Next
                                </Button> :
                            <Button style={{ width: '7vw', marginTop: 0, marginBottom: '20px' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.assignFiles()}>
                                Assign
                                 </Button>
                        }
                    </div>
                </DialogContent>

            </Dialog>

        )
    }
}
export default withStyles(dashboardStyles, { withTheme: true })(withRouter(FileAssignment));

/*endAdornment: <InputAdornment position="end"> | &nbsp;
<div>
        <Select
            style={{ color: 'white' }}
            disableUnderline
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selected}
            onChange={this.handleChange}
            inputProps={{
                classes: {
                    icon: classes.icon,
                },
            }}
        >

            <MenuItem value="edit">Can Edit</MenuItem>
            <MenuItem value="process" >Can Process</MenuItem>
        </Select>
    </div>
</InputAdornment>*/
